<script>
	import unserlineorder from '../unserlineorder/index.vue'
	export default {
		extends: unserlineorder,
		name: 'equityIndex',
		data() {
			return {
				windowName: '权益开票',
				// windowType: 'modal',
				windowType: 'window',
				currentrow: {},
				showIsdrop: 0,
				type:'equity'
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
	
		},
		computed: {

		},

		methods: {
			initList() {
				this.toolbarButtonConfig = ['add','enter', 'autoinvoice', 'autoredinvoice']
				this.operateButtonConfig = ["edit", "detail", "drop", "del"]
				this.columns = [{
					type: 'checkbox',
					field: 'code',
					title: '单据编码',
					width: 120,
					render:'$input'
				}, {
					field: 'invoiceType',
					title: '发票类型',
					width: 100,
					props: {
						type: 'select',
						selectoptions: [{
							label: '专票',
							value: '01'
						}, {
							label: '普票',
							value: '02'
						}]
					},

				}, {
					field: 'totalAmount',
					title: '价税合计(元)',
					width: 100
				}, {
					field: 'spfEmail',
					title: '收票方邮箱',
					width: 100
				}, {
					field: 'gmfMc',
					title: '购方名称',
					width: 100,
					render:'$input'
				}, {
					field: 'xsfMc',
					title: '销方名称',
					width: 100,
					render:'$input'
				}, {
					field: 'staffid',
					title: '申请人',
					width: 100,
					formatter: 'staff'
				}, {
					field: 'commit_time',
					title: '申请时间',
					width: 100,
					formatter: 'date'
				}, {
					field: 'invoicenumber',
					title: '发票号码',
					width: 100,
					render:'$input'
				}, {
					field: 'invoicetime',
					title: '开票日期',
					width: 100,
					formatter: 'date'
				}, {
					field: 'invoiceamount',
					title: '发票价税合计',
					width: 100
				}, {
					field: 'bz',
					title: '备注',
					width: 100
				}, {
					field: 'status',
					title: '开票状态',
					render:'$select',
					props: {
						multiple:true,
						type: 'select',
						selectoptions: [{
								"value": 0,
								"label": "未开票"
							},
							{
								"value": 1,
								"label": "待开票"
							},
							{
								"value": 2,
								"label": "审核中"
							},
							{
								"value": 3,
								"label": "开票中"
							},
							{
								"value": 4,
								"label": "已开票"
							},
							{
								"value": 5,
								"label": "待冲红"
							},
							{
								"value": 6,
								"label": "冲红中"
							},
							{
								"value": 7,
								"label": "已冲红"
							},
							{
								"value": 90,
								"label": "开票失败"
							},
							{
								"value": 91,
								"label": "冲红失败"
							}
						]
					},
					width: 100
				}, {
					field: 'error',
					title: '错误信息',
					width: 100
				}]

				this.initToolbarButton()
				this.initOperateButton()
				this.initOption()
			},
			toolbarButtonClickEvent(e) {
				this[e.code]()
			},
			operateButtonClickEvent(e) {
				this[e.code](e.data)
			},
			add() {
				this.addformShow({
					componentname: 'equityform'
				})
			},
			edit(row) {
				this.editformShow(row, {
					componentname: 'equityform'
				})
			},
			enter(){
				this.$refs.enterForm.modal_show()
			},
			enterFormSuccess(){
				this.customreload()
			}
		},
		components: {

		}
	}
</script>